import React, { useState } from 'react';
import tanuragalogo from "../assets/images/tanuraga-logo.png";
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import { apiUrl } from '../config/Config';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Spinner from "react-activity/dist/Spinner";

const Register = () => {
  let navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const requestedRedirect = location.state?.redirectTo || searchParams.get('redirect') || '/';
  const redirectTo = requestedRedirect.startsWith('/') && !requestedRedirect.startsWith('//') ? requestedRedirect : '/';
  const [fullname, setfullname] = useState("");
  const [email, setemail] = useState("");
  const [number, setnumber] = useState("");
  const [address, setaddress] = useState("");
  const [area, setarea] = useState("");
  const [landmark, setlandmark] = useState("");
  const [pincode, setpincode] = useState("");
  const [state, setstate] = useState("");
  const [city, setcity] = useState("");
  const [password, setpassword] = useState("");
  const [repassword, setrepassword] = useState("");
  const [showloding, setshowloding] = useState(false);

  const isValidEmail = (email) => {
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return pattern.test(email);
  };

  const isValidPhone = (phone) => {
    if (!phone) return false;
    const pattern = /^(\+91[\-\s]?)?[6-9][0-9]{9}$/;
    return pattern.test(phone.trim());
  };

  const handleregistrationsubmit = async() => {
    if(fullname && email && number && address && area && pincode && state && city && password && repassword) {

    } else {
      Swal.fire({
        title: "",
        text: "Mandatory fields are required",
        icon: "error",
        customClass: {
          icon: "custom-swal-icon", // Apply the custom class
        },
        width: "350px",
        confirmButtonText: "Ok",
        confirmButtonColor: "rgb(59, 151, 196)",
        customClass: {
          popup: "small-icon-alert",
        },
      });
      return;
    }

    if(isValidEmail(email)) {}
    else {
      Swal.fire({
        title: "",
        text: "Invalid Email address",
        icon: "error",
        customClass: {
          icon: "custom-swal-icon", // Apply the custom class
        },
        width: "350px",
        confirmButtonText: "Ok",
        confirmButtonColor: "rgb(59, 151, 196)",
        customClass: {
          popup: "small-icon-alert",
        },
      });
      return;
    }

    if(isValidPhone(number)) {}
    else {
      Swal.fire({
        title: "",
        text: "Invalid Mobile Number",
        icon: "error",
        customClass: {
          icon: "custom-swal-icon", // Apply the custom class
        },
        width: "350px",
        confirmButtonText: "Ok",
        confirmButtonColor: "rgb(59, 151, 196)",
        customClass: {
          popup: "small-icon-alert",
        },
      });
      return;
    }

    if(password == repassword) {}
    else {
      Swal.fire({
        title: "",
        text: "Password and re-password does not match",
        icon: "error",
        customClass: {
          icon: "custom-swal-icon", // Apply the custom class
        },
        width: "350px",
        confirmButtonText: "Ok",
        confirmButtonColor: "rgb(59, 151, 196)",
        customClass: {
          popup: "small-icon-alert",
        },
      });
      return;
    }

    var data = {
      fullname: fullname,
      email: email,
      number: number,
      address: address,
      area: area,
      landmark: landmark,
      pincode: pincode,
      state: state,
      city: city,
      password: password
    }
    console.log('data >>', data);
    setshowloding(true);
    const headers = {
      headers: {
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*'
      }
    }
    let resp = await axios.post(apiUrl + 'registernewcustomer', data, headers).then(async(res) => {
      if(res.data.status == 'success') {
        // dispatch({ type: "customerdata", payload: res.data.data })
        // navigate('/admin/dashboard');
        await Swal.fire({
          title: '',
          text: 'Registered successfully!! Please try again to login',
          icon: 'success',
          customClass: {
            icon: 'custom-swal-icon' // Apply the custom class
          },
          width: '350px',
          confirmButtonText: 'Ok',
          confirmButtonColor: "rgb(59, 151, 196)",
          customClass: {
              popup: "small-icon-alert",
            },
        });
        navigate('/login', { state: { redirectTo }, replace: true });
      } else {
        Swal.fire({
          title: '',
          text: res.data.message,
          icon: 'error',
          customClass: {
            icon: 'custom-swal-icon' // Apply the custom class
          },
          width: '350px',
          confirmButtonText: 'Ok',
      confirmButtonColor: "rgb(59, 151, 196)",
          customClass: {
              popup: "small-icon-alert",
            },
        });
        
      }
  } ).catch((err) => {
      alert(err.message)
  })
    setshowloding(false);

  }

  return (
    <div className="register-page-container">
      <div className="register-page-card newregister-page-card">
        {/* Logo and Tagline */}
        <div className="register-page-header">
          {/* In a real project, replace <Logo /> with <img src="/path/to/logo.png" alt="PickBazar" /> */}
          <h2 className="register-page-logo">
            <img src={tanuragalogo} className="loginpagelogo" />
          </h2>
          <p className="register-page-tagline">Register new account</p>
        </div>

        {/* Form */}
        <div className="register-page-form" >
          {/* Name Field */}
          <div className="register-page-form-group">
            <label htmlFor="name" className="register-page-label">
              Full Name *
            </label>
            <input
              type="text"
              className="register-page-input"
              placeholder='Enter Your Full Name'
              value={fullname}
              onChange={(t) => {setfullname(t.target.value)}}
            />
          </div>

          <div className="row">
            <div className="col-12 col-sm-6">
              <div className="register-page-form-group">
                <label htmlFor="email" className="register-page-label">
                  Email *
                </label>
                <input
                  type="email"
                  placeholder='Enter Your Email'
                  className="register-page-input"
                  value={email}
                  onChange={(t) => {setemail(t.target.value)}}
                />
              </div>
            </div>
            <div className="col-12 col-sm-6">
              <div className="register-page-form-group">
                <label htmlFor="email" className="register-page-label">
                  Phone Number *
                </label>
                <input
                  type="text"
                  placeholder='Enter Your Phone Number'
                  className="register-page-input"
                  value={number}
                  onChange={(t) => {setnumber(t.target.value)}}
                />
              </div>
            </div>
          </div>

          <div className="register-page-form-group">
            <label htmlFor="name" className="register-page-label">
              Address <sub>(Flat no. , Apartment name etc) *</sub>
            </label>
            <input
              type="text"
              placeholder='Enter Your Address'
              className="register-page-input"
              value={address}
              onChange={(t) => {setaddress(t.target.value)}}
            />
          </div>

          <div className="row">
            <div className="col-12 col-sm-6">
              <div className="register-page-form-group">
                <label htmlFor="email" className="register-page-label">
                  Area / Village *
                </label>
                <input
                  type="text"
                  placeholder='Enter Your Area'
                  className="register-page-input"
                  value={area}
                  onChange={(t) => {setarea(t.target.value)}}
                />
              </div>
            </div>
            <div className="col-12 col-sm-6">
              <div className="register-page-form-group">
                <label htmlFor="email" className="register-page-label">
                  Pincode *
                </label>
                <input
                  type="text"
                  placeholder='Enter Your Pincode'
                  className="register-page-input"
                  value={pincode}
                  onChange={(t) => {setpincode(t.target.value)}}
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12 col-sm-6">
              <div className="register-page-form-group">
                <label htmlFor="email" className="register-page-label">
                  State *
                </label>
                <input
                  type="text"
                  placeholder='Enter Your State'
                  className="register-page-input"
                  value={state}
                  onChange={(t) => {setstate(t.target.value)}}
                />
              </div>
            </div>
            <div className="col-12 col-sm-6">
              <div className="register-page-form-group">
                <label htmlFor="email" className="register-page-label">
                  City *
                </label>
                <input
                  type="text"
                  placeholder='Enter Your City'
                  className="register-page-input"
                  value={city}
                  onChange={(t) => {setcity(t.target.value)}}
                />
              </div>
            </div>
          </div>



          <div className="row">
            <div className="col-12 col-sm-6">
              <div className="register-page-form-group">
                <label htmlFor="password" className="register-page-label">
                  Password *
                </label>
                <div className="register-page-password-wrapper">
                  <input
                    type="password"
                    placeholder='Enter Your Password'
                    className="register-page-input"
                    value={password}
                    onChange={(t) => {setpassword(t.target.value)}}
                  />

                  <span className="register-page-password-icon">
                    {/* Replace with your preferred icon library, e.g., an SVG or Font Awesome */}
                    
                  </span>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6">
              <div className="register-page-form-group">
                <label htmlFor="password" className="register-page-label">
                  Re-type Password *
                </label>
                <div className="register-page-password-wrapper">
                  <input
                    type="password"
                    placeholder='Retype Your Password'
                    className="register-page-input"
                    value={repassword}
                    onChange={(t) => {setrepassword(t.target.value)}}
                  />

                  <span className="register-page-password-icon">
                    {/* Replace with your preferred icon library, e.g., an SVG or Font Awesome */}
                    
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Register Button */}
          <button type="submit" className="register-page-button" onClick={() => {handleregistrationsubmit()}}>
            {
              showloding ?
              <Spinner color='#fff' size={15} className='spinnerCenter' /> :
              "Register"
            }
            
          </button>
        </div>

        {/* Footer Links */}
        <p className="register-page-separator">Or</p>
        <p className="register-page-footer">
          Already have an account?{" "}
          <Link to={'/login'} state={{ redirectTo }} className="register-page-link">Login</Link>
        </p>
      </div>
    </div>
  );
};

export default Register;
